export default "__VITE_ASSET__BCnci_Jf__"